// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2BxXB","author":"Table_author__1og_i","authorImage":"Table_authorImage__36oYp","unreadRow":"Table_unreadRow__19YoK"};